import { IToken } from "./itoken";

export function calculateTokenTime(token:IToken) : number {
    if (!token.expires) return 0;
    
    const timeleft = new Date(token.expires).getTime() - new Date().getTime();
    return timeleft;
};
